// extracted by mini-css-extract-plugin
export default {"header":"Header-module--header--NXzL8","headerWrapper":"Header-module--header-wrapper--19iS5"};